import React from 'react';

import './spinner.css';

class Spinner extends React.Component {
    render() {
        const { addClass = undefined } = this.props;
        return (
            <div className={`spinner ${addClass ? addClass : ''}`}>
                <i className='fa fa-spinner fa-pulse'/>
                <span>Carregando, isso pode demorar algum tempo</span>
            </div>
        );
    }
}

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/spinner/spinner.js